import React from 'react';
import FontAwesome from 'react-fontawesome';
import Router, { Route, Switch } from 'react-router';

import InventoryDetail from 'containers/pages/inventory/detail/InventoryDetail';
import Inventory from 'containers/pages/inventory/Inventory';

import { InventoryFilterDataState } from 'redux/modules/inventory_filter_data';

export interface StateProps {
    inventory_filter_data: InventoryFilterDataState;
}

export interface DispatchProps {
    load_filter_data(): void;
}

export interface OwnProps {
    match: Router.match<{}>;
}

type CombinedProps = StateProps & DispatchProps & OwnProps;

class InventoryPage extends React.Component<CombinedProps> {
    public componentDidMount() {
        if (this.props.inventory_filter_data.categories.length < 1) this.props.load_filter_data();
    }

    public render() {
        const { match } = this.props;
        return this.props.inventory_filter_data.categories.length < 1
        ? (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />)
        : (
            <Switch>
                <Route path={match.url} exact component={Inventory} />
                <Route path={`${match.url}/category/:category_name`} component={Inventory} />
                <Route path={`${match.url}/:item_alias_end`} component={InventoryDetail} />
            </Switch>
        );
    }
}

export default InventoryPage;



// WEBPACK FOOTER //
// ./src/components/pages/inventory/InventoryPage.tsx